// extracted by mini-css-extract-plugin
export default {"chart":"trendByPortfolio_chart__jO0fA","pdb4":"trendByPortfolio_pdb4__eO3WF","table":"trendByPortfolio_table__kulgi"};